var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.post.url,"target":"_blank"}},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('picture',{staticClass:"embed-responsive-item img-fluid",style:({ backgroundImage: `url(${_vm.post.thumb_url})`})})]),_c('p',[_vm._v(_vm._s(_vm.post.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }